import { ISaveAsDraftRequest } from '../entities/services';
import { ProjectHelper } from '@bimser/common';

export const SaveAsDraft = (payload: ISaveAsDraftRequest) =>
	ProjectHelper.RunPromiseFormService({
		projectName: payload.projectName,
		formName: payload.formName,
		serviceName: 'SaveAsDraft',
		requestParameters: payload.requestParameters
	});
